import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import Classes from './Faq.module.css';
import { FAQS } from '../../../../../data/faqs';

export default function Faq() {
    return (
        <section id="faq" className="section">
            <div className={`container ${Classes.grid}`}>
                <div className={Classes.intro}>
                    <div className="eyebrow">FAQs</div>
                    <h2 className="section-title">Frequently Asked Questions</h2>
                    <p className="section-lead">
                        Answers to common questions about our services and booking. Still have a question?
                    </p>
                    <div className={Classes.buttons}>
                        <Link to="/contact-us" className="btn btn-dark">Contact Us</Link>
                    </div>
                </div>

                <div className={Classes.list}>
                    {FAQS.map((faq, i) => (
                        <details key={faq.question} className={Classes.item} open={i === 0}>
                            <summary>
                                <span>{faq.question}</span>
                                <FaChevronRight className={Classes.icon} />
                            </summary>
                            <p>{faq.answer}</p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
}
